import { Amplify } from "aws-amplify"

const configureAmplify = (): void => {
  Amplify.configure({
    Auth: {
      Cognito: {
        identityPoolId: process.env.AMPLIFY_AUTH_IDENTITY_POOL_ID || "",
        userPoolId: process.env.AMPLIFY_AUTH_USER_POOL_ID || "",
        userPoolClientId: process.env.AMPLIFY_AUTH_USER_POOL_WEB_CLIENT_ID || "",
      },
    },
    Storage: {
      S3: {
        bucket: process.env.AMPLIFY_STORAGE_S3_BUCKET,
        region: process.env.AMPLIFY_STORAGE_AUTH_REGION,
      },
    },
  })
}

export default configureAmplify
